import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a211480"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradientOverlay" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = { class: "fev_text1 fw_800 question" }
const _hoisted_4 = { class: "answers_div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "imageCardContainer bg_blue mb-4",
      style: _normalizeStyle('background-image: url(\'' + _ctx.backgroundImage + '\')')
    }, [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.profileQuestion.question), 1)
    ], 4),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileQuestion.answers, (answer, index) => {
        return (_openBlock(), _createElementBlock("button", {
          class: _normalizeClass(["fev_button mb-3", _ctx.getButtonClass(index)])
        }, [
          _createElementVNode("span", null, _toDisplayString(answer), 1)
        ], 2))
      }), 256))
    ])
  ], 64))
}